import { init_tooltips, dispose_tooltips } from "@/utils/bootstrap_tooltips";

export default {
  props: {
    sidebar_collapsed: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return ({
      _tooltip_instances: []
    });
  },

  mounted() {
    this.sync_collapsed_tooltips();
  },

  watch: {
    sidebar_collapsed() {
      this.sync_collapsed_tooltips();
    }
  },

  beforeUnmount() {
    dispose_tooltips(this._tooltip_instances);
  },

  methods: {
    sync_collapsed_tooltips() {
      dispose_tooltips(this._tooltip_instances);
      this._tooltip_instances = this.sidebar_collapsed ? init_tooltips(this.$el) : [];
    }
  }
};
